import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  interfaceData: [],
  destinationTablesData: [],
  businessAdvisorMapsData: [],
  businessAdvisorMapsToBrandsData: null,
  gapRulesData: [],
};

const advisorSlice = createSlice({
  name: "advisor",
  initialState: initialState,
  reducers: {
    setInterfaceData: (state, action) => {
      state.interfaceData = action.payload;
    },
    setDestinationTablesData: (state, action) => {
      state.destinationTablesData = action.payload;
    },
    setBusinessAdvisorMapsData: (state, action) => {
      state.businessAdvisorMapsData = action.payload;
    },
    setBusinessAdvisorMapsToBrandsData: (state, action) => {
      state.businessAdvisorMapsToBrandsData = action.payload;
    },
    setGapRulesData: (state, action) => {
      state.gapRulesData = action.payload;
    },
    resetAdvisorData: () => initialState,
  },
});

export const {
  setInterfaceData,
  setDestinationTablesData,
  setBusinessAdvisorMapsData,
  setBusinessAdvisorMapsToBrandsData,
  setGapRulesData,
  resetAdvisorData,
} = advisorSlice.actions;

export default advisorSlice.reducer;
